/*
 * Public API Surface of alerts
 */

export { CbreSnackBarOptions, CbreToastrOptions, ComplexTranslation, TranslationFunction } from './lib/alerts.model';
export * from './lib/alerts.module';
export { CbreAlertService, CBRE_ALERTS_TRANSLATION_FUNCTION } from './lib/alerts.service';
export { CustomSnackComponent } from './lib/custom-snack/custom.snack.component';
